import {Injectable, Inject } from 'ng-metadata/core';
import {SharedSessionStorage} from '../../../infra/sharedSessionStorage.service';
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";

const clone= require('lodash/clone');

@Injectable()
export class PersonalizeResultsButtonService {

    private _enable:boolean = false;
    private _recentness:boolean = false;
    private _editPressed:boolean = false;
    private _cancelPressed:boolean = false;
    private _promise:any;
    private _searchParams;
    private userSettingsUrl:string;

    constructor(private sharedSessionStorage: SharedSessionStorage,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$q') private $q,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('$state') private $state: ng.ui.IStateService) {

        let enable = this.sharedSessionStorage.getItem('enable_personalization');
        if (enable !== null && this.sharedSessionStorage.getItem('personalization') !== null) {
            this.enable = (enable === "true") ? true : false;
        }
        else if (enable !== null && this.sharedSessionStorage.getItem('personalization') === null) {
            this.sharedSessionStorage.removeItem('enable_personalization');
        }
        let recentness = this.sharedSessionStorage.getItem('recentness');
        if (recentness !== null && this.sharedSessionStorage.getItem('personalization') !== null) {
            this.recentness = (recentness === "true") ? true : false;
        }
        this.userSettingsUrl = restBaseURLs.userSettingsBaseURL;
    }


    public displayDialog() {
        if ((this.enable && (this.sharedSessionStorage.getItem('personalization') === null && !this.cancelPressed)) || this.editPressed)  {
            return true;
        }
        return false;
    }

    public personalizationToggled() {
        if (this.enable && (this.sharedSessionStorage.getItem('personalization') !== null) && (this.$state.current.name !== STATE_NAMES.NEWSPAPERS))  {
            return true;
        }
        return false;
    }

    public  updatePersonalization(view:string):any {
        if (this.sharedSessionStorage.getItem("personalization")) {
            return this.setUserPersonalizationPreferencesToDB(view);
        }
        else {
            return this.getUserPersonalizationPreferencesFromDB(view);
        }

    }

    public setUserPersonalizationPreferencesToDB(view:string) {
        let payload = this.buildPersonalizationPaylod(view);
        return this.$http.post(this.userSettingsUrl, payload);
    }

    private buildPersonalizationPaylod(view:string){
        let personalizatopnPreferences = this.sharedSessionStorage.getItem('personalization')? this.sharedSessionStorage.getItem('personalization'):"";
        return {
            'vid': view,
            'pr-discipline': personalizatopnPreferences,
            'pr-recentness': this.recentness,
            'pr-enabled': this.enable
        };
    }
    public addCameFromPersonalizationParam(){
        let pageLinkParams = clone(this.$stateParams);
        pageLinkParams.came_from = "personalization";
        this.searchParams =  pageLinkParams;
    }


    public getUserPersonalizationPreferencesFromDB(vid:string) {
        let deferred = this.$q.defer();
        let userDetailsUrl = this.userSettingsUrl + '?vid=' + vid;
        this.$http({
            method: 'GET',
            url: userDetailsUrl,
        }).then((response) => {
            let data = response.data;
            if (data['pr_discipline']) {
                this.sharedSessionStorage.setItem('personalization', data['pr_discipline']);
                this.recentness = data['pr_recentness'] === 'true' || data['pr_recentness']=== '1';
                if (data['pr_enabled']) {
                    this.enable = data['pr_enabled'] === 'true'; // convert string to boolean
                    this.sharedSessionStorage.setItem('enable_personalization', this.enable);
                }
                else{
                    this.enable = true;
                    this.sharedSessionStorage.setItem('enable_personalization', 'true');
                }

            }
        }).then( // the search state blocked until this promise will be resolved in purpose to set personalization before the search start,
                 // if this promise failed we don't want to block all the search state
            (res) => {
                deferred.resolve(res);
            },
            (err) => {
                deferred.resolve(err);
            }
        );
        return deferred.promise;
    }
    set cancelPressed(value: boolean) {
        this._cancelPressed = value;
    }
    get cancelPressed(): boolean {
        return this._cancelPressed;
    }
    set recentness(value: boolean) {
        this._recentness = value;
    }
    get promise(): any {
        return this._promise;
    }
    set editPressed(value: boolean) {
        this._editPressed = value;
    }
    get editPressed(): boolean {
        return this._editPressed;
    }
    set promise(value: any) {
        this._promise = value;
    }
    get recentness(): boolean {
        return this._recentness;
    }
    set enable(value: boolean) {
        this._enable = value;
    }
    get enable(): boolean {
        return this._enable;
    }
    get searchParams() {
        return this._searchParams;
    }
    set searchParams(value) {
        this._searchParams = value;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/personalization/personalizationButton/personalizeResultsButton.service.ts